module.exports = __webpack_public_path__ + "media/images/moscow_01_small-f18a5b562b2e16ab532b20e06ce8bcfb.jpg";